import InputField from 'components/molecules/input-field'
import InputSelectOptions from 'components/molecules/input-select-options'
import LoaderButton from 'components/molecules/loader-button'
import ConfirmationModal from 'components/organisms/confirmation-modal'
import { REFUNDABLE_ORDER_ITEM_STATUS, REFUND_REASON } from 'domains/customer-order/constants'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import customerOrderRefundScheme from './customer-order-refund-schema'


const propTypes = {
  selectedOrderItem : PropTypes.object,
  onSubmitForm      : PropTypes.func
}

const defaultProps = {
  selectedOrderItem : {},
  onSubmitForm      : () => {}
}

/**
 * Form to create customer refund by Ops
 * @param {object} selectedOrderItem Selected Customer Order
 * @param {func} onSubmitForm Handler props to submit the form
 */
const CustomerOrderRefundForm = ({
  selectedOrderItem,
  onSubmitForm
}) => {
  const [ isConfirmationModalOpen, setIsConfirmationModalOpen ] = useState(false)

  /** Toggle to show/hide confirmation modal */
  const handleToggleModal = () => setIsConfirmationModalOpen((prev) => !prev)

  /**
   * Show/hide required badge in reason detail field
   * @param {object} formikBag - Formik props
   */
  const isReasonDetailRequired = (formikBag) => {
    const { values: { reason } } = formikBag

    return REFUND_REASON.OTHERS === reason
  }
  const isOpsCanRefund = Object.values(REFUNDABLE_ORDER_ITEM_STATUS['ops_before_shipping']).includes(selectedOrderItem.status)

  return (
    <Formik
      enableReinitialize={ false }
      initialValues={{
        reason         : '',
        reason_details : '',
        ops_notes      : '',
        cs_notes       : '',
        quantity       : '',
        initiated_by   : isOpsCanRefund ? 'ops_before_shipping' : 'cs'
      }}
      validationSchema={ customerOrderRefundScheme(selectedOrderItem) }
      onSubmit={ () => handleToggleModal() }
    >
      {
        (formikBag) => (
          <Form>
            <InputField
              name='reason'
              label='reason'
              type='select'
              required={ true }
            >
              <InputSelectOptions
                options={ REFUND_REASON }
                keyPrefix='refund-reason'
              />
            </InputField>

            <InputField
              name='reason_details'
              label='reason details'
              type='textarea'
              required={ isReasonDetailRequired(formikBag) }
            />

            <InputField
              name='quantity'
              label='Quantity'
              type='number'
              required={ true }
            />

            {
              isOpsCanRefund ?
                <InputField
                  name='ops_notes'
                  label='ops notes'
                  type='textarea'
                /> :
                <InputField
                  name='cs_notes'
                  label='cs notes'
                  type='textarea'
                />
            }

            <LoaderButton
              color='primary'
              type='submit'
              onSubmit={ formikBag.submitForm }
              disabled={ formikBag.isSubmitting }
              isLoading={ formikBag.isSubmitting }
              text='Submit the refund'
            />

            <ConfirmationModal
              title={ 'Refund item' }
              isOpen={ isConfirmationModalOpen }
              toggle={ () => {
                handleToggleModal()
                // Enable the submit button when user cancel the confirmation modal
                formikBag.setSubmitting(false)
              } }
              handleConfirmation={ () => {
                onSubmitForm(formikBag.values, formikBag)
                handleToggleModal()
              } }
            >
              { 'Are you sure want to refund this item?' }
            </ConfirmationModal>
          </Form>
        )
      }
    </Formik>
  )
}

CustomerOrderRefundForm.propTypes    = propTypes
CustomerOrderRefundForm.defaultProps = defaultProps

export default CustomerOrderRefundForm
